import { render, staticRenderFns } from "./VuexTab.vue?vue&type=template&id=d8a399ec&"
import script from "./VuexTab.vue?vue&type=script&lang=js&"
export * from "./VuexTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a399ec')) {
      api.createRecord('d8a399ec', component.options)
    } else {
      api.reload('d8a399ec', component.options)
    }
    module.hot.accept("./VuexTab.vue?vue&type=template&id=d8a399ec&", function () {
      api.rerender('d8a399ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/vuex/VuexTab.vue"
export default component.exports